//Redux
import { useDispatch } from "react-redux";
import { setComponentActive, setOrder } from "../../reducers/userConfigSlice";
import { Button } from "@delibrandev/utils";
import { FiShoppingBag } from "react-icons/fi";
import "./style.css";

export const DeliveryDone = () => {
  const dispatch = useDispatch();

  const handleNavigation = (component, order = null) => {
    order !== null && dispatch(setOrder(order));
    dispatch(setComponentActive("" + component));
  };

  return (
    <div className="paymentDone">
      <div className="paymentresponse">
        <div className="paymentIcon">
          <FiShoppingBag />
        </div>
        <div className="paymentTitle">¡Pedido entregado!</div>
        <div className="paymentDescription">El pedido ha sido entregado con éxito.</div>
      </div>
      <div className="paymentDoneAction">
        <Button text={"Volver a pedidos"} icon={null} customClass={""} action={() => handleNavigation("delivery")} />
      </div>
    </div>
  );
};
